import { render, staticRenderFns } from "./FCellEmail.vue?vue&type=template&id=2727bd5e&"
import script from "./FCellEmail.vue?vue&type=script&lang=ts&"
export * from "./FCellEmail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports